var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box body-medium",style:(`background:${_vm.color};`)},[_c('q-icon',{attrs:{"name":`svguse:/icons.svg#${_vm.icon}`,"size":"32px","title":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }